import {
    Box,
    Checkbox,
    Collapse,
    FormControlLabel,
    FormGroup,
    List,
    ListItemButton,
    ListItemText,
    ListSubheader,
    Typography
} from "@mui/material"
import { MdClear } from "react-icons/md"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { useState, useEffect, useReducer } from "react"

// Reducer for managing section open/close state
const sectionReducer = (state, action) => {
    switch (action.type) {
        case 'TOGGLE_SECTION':
            return {
                ...state,
                [action.sectionId]: !state[action.sectionId]
            }
        case 'OPEN_ALL':
            return {
                ...state,
                categories: true,
                status: true
            }
        case 'CLOSE_ALL':
            return {
                ...state,
                categories: false,
                status: false
            }
        default:
            return state
    }
}

// Reducer for managing selected filters
const filterReducer = (state, action) => {
    switch (action.type) {
        case 'TOGGLE_FILTER':
            const { sectionId, item } = action
            const currentFilters = state[sectionId] || []
            const isSelected = currentFilters.includes(item)

            return {
                ...state,
                [sectionId]: isSelected
                    ? currentFilters.filter(filter => filter !== item)
                    : [...currentFilters, item]
            }
        case 'CLEAR_ALL_FILTERS':
            return {
                categories: [],
                status: []
            }
        default:
            return state
    }
}

// Initial state for sections
const initialSectionState = {
    categories: false,
    status: false
}

// Initial state for selected filters
const initialFilterState = {
    categories: [],
    status: []
}

const ExamFilter = (props) => {
    const { data, leadFilterFunction, componentName } = props

    const COMPONENT_CATEGORIES = {
        examTips: ["Speaking", "Reading", "Writing", "Listening", "Question Bank", "Exam Tips", "Grammar", "Live Class"],
        questionBank: ["Speaking", "Reading", "Writing", "Listening", "Question Bank", "Exam Tips", "Grammar", "Live Class"],
        course: ["Offline", "Online", "Offline & Online"],
        liveClass: ["Speaking", "Reading", "Writing", "Listening", "Question Bank", "Exam Tips", "Grammar", "Live Class"],
        learningTopics: ["Speaking", "Reading", "Writing", "Listening", "Question Bank", "Exam Tips", "Grammar", "Live Class"],
        ieltsCenter: data
    };
    // const [categories] = useState(["Speaking", "Reading", "Writing"])
    const categories = COMPONENT_CATEGORIES[componentName] || []
    const [status] = useState(["Active", "Inactive"])

    // useReducer for managing section open/close state
    const [openSections, sectionDispatch] = useReducer(sectionReducer, initialSectionState)

    // useReducer for managing selected filters
    const [selectedFilters, filterDispatch] = useReducer(filterReducer, initialFilterState)

    // Call leadFilterFunction whenever selectedFilters changes
    useEffect(() => {
        leadFilterFunction(selectedFilters)
    }, [selectedFilters])

    // Toggle section function
    const toggleSection = (sectionId) => {
        sectionDispatch({ type: 'TOGGLE_SECTION', sectionId })
    }

    // Handle checkbox change
    const handleCheckboxChange = (sectionId, item) => {
        filterDispatch({ type: 'TOGGLE_FILTER', sectionId, item })
    }

    // Clear all function - clears filters and opens all sections
    const handleClearClick = () => {
        filterDispatch({ type: 'CLEAR_ALL_FILTERS' })
        sectionDispatch({ type: 'OPEN_ALL' })
    }

    const filterSections =
        componentName === "examTips" ||
            componentName === "questionBank" ||
            componentName === "liveClass" ||
            componentName === "learningTopics"
            ? [
                { id: 'categories', title: 'Categories' },
                { id: 'status', title: 'Status' }
            ]
            : componentName === "ieltsCenter" ? 
            [
                { id: "location",title: "Location" },
                { id: "status", title: "Status"}
            ] 
            : 
            [
                { id: 'categories', title: 'Course Type' },
                { id: 'status', title: 'Status' }
            ];


            const filterData =
            componentName === "ieltsCenter"
                ? {
                    location: data,
                    status
                }
                : {
                    categories,
                    status
                }

      
    return (
        <>
            <List
                sx={{
                    maxWidth: "316px",
                    height: "auto",
                    bgcolor: "background.paper",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    border: "1px solid #ECECEC",
                    mt: 2.5,
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                        sx={{ backgroundColor: "#F2F2F2" }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div>Filter</div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    gap: "4px"
                                }}
                                onClick={handleClearClick}
                            >
                                <MdClear style={{ fontSize: "18px" }} />
                                <Typography variant="body2">Clear All</Typography>
                            </div>
                        </div>
                    </ListSubheader>
                }
            >
                {filterSections.map((section) => (
                    <div key={section.id}>
                        <ListItemButton onClick={() => toggleSection(section.id)}>
                            <ListItemText primary={section.title} />
                            {openSections[section.id] ? (
                                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                            ) : (
                                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                            )}
                        </ListItemButton>

                        <Collapse in={openSections[section.id]} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 2 }}>
                                    <FormGroup>
                                        {filterData[section.id] && filterData[section.id].length > 0 ? (
                                            filterData[section.id]?.map((item, index) => (
                                                <FormControlLabel
                                                    key={`${section?.id}-${index}`}
                                                    control={
                                                        <Checkbox
                                                            sx={{
                                                                color: "#F8469A",
                                                                "&.Mui-checked": {
                                                                    color: "#F8469A",
                                                                },
                                                            }}
                                                            checked={selectedFilters[section.id]?.includes(item) || false}
                                                            onChange={() => handleCheckboxChange(section.id, item)}
                                                        />
                                                    }
                                                    label={section?.id === "location" ? item?.location :  item}
                                                />
                                            ))
                                        ) : (
                                            <Typography variant="body2" color="text.secondary">
                                                No items to display
                                            </Typography>
                                        )}
                                    </FormGroup>
                                </ListItemButton>
                            </List>
                        </Collapse>
                    </div>
                ))}
            </List>

            <Box
                component="form"
                sx={{
                    display: "flex",
                    gap: "10px",
                    mt: "29px",
                    alignItems: "center",
                    "& input": {
                        border: "1px solid #B8BECC",
                        borderRadius: "4px",
                        outline: "none",
                        maxWidth: "80px",
                        textAlign: "center",
                        fontSize: "16px",
                        lineHeight: "24px",
                        padding: "5px 17px"
                    }
                }}
            >
                <Typography
                    sx={{
                        fontSize: "14px",
                        lineHeight: "19px"
                    }}
                >
                    Showing Entries
                </Typography>
                <input
                    type="number"
                    defaultValue={10}
                />
                <input type="submit" style={{ display: "none" }} />
            </Box>
        </>
    )
}

export default ExamFilter